module.exports = __webpack_public_path__ + "img/A971A9_E8CBE8_D4A8D4_DCB3DC-256px.7a2a5102.png";